export default () => {
  const sendMyDocument = $(".js-send-my-document"),
        sendMyDocumentButton = $(".js-send-my-document-button"),
        signMyDocumentButton = $(".js-sign-my-document-button"),
        signMyDocumentId = $("#signMyDocument"),
        sendMyDocumentId = $("#sendMyDocument"),
        sendMyDocumentForm = $("#sendMyDocumentForm"),
        signMyDocumentForm = $("#signMyDocumentForm"),
        loadingDocumentsButton = $(".loading-documents-list__item"),
        loader = $(".loader");

  sendMyDocument.on("click", function (event) {
    event.preventDefault();
    $(event.target).siblings().focus().trigger("click");
    loadingDocumentsButton.blur();
  });

  sendMyDocumentButton.on("click keyup", function (event) {
    if (event.keyCode === 13) {
      sendMyDocumentId.focus().trigger("click");
    }
  });

  signMyDocumentButton.on("keyup", function (event) {
    if (event.keyCode === 13) {
      signMyDocumentId.focus().trigger("click");
    }
  });

  sendMyDocumentId.change(function () {
    sendMyDocumentForm.submit();
    initLoader(loader);
  });

  signMyDocumentId.change(function () {
    signMyDocumentForm.submit();
    initLoader(loader);
  });
}